import styles from './full.module.css';

export default function Fullloading({ status }) {
    return (
        <main className={`${styles.main} ${status ? styles.hide : ''}`}>

        </main>
    )
}